module.exports = __webpack_public_path__ + "static/media/FrameCollection1.8f1a3ab3.png";